import React, { useEffect, useState } from "react";
import Search from "../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg15 from "../../../../../../assets/svg/svg15.svg";
import svg29 from "../../../../../../assets/svg/svg29.svg";
import { Link, useNavigate } from "react-router-dom";
import CardLoading from "../../../../../../components/CardLoading";
import MembersView from "./MembersView";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import MembersAdd from "./MembersAdd";
import { fetchData } from "../../../../../../features/fetch/fetchSlice";
import moment from "moment";

function MembersTable({ setView }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const url = "prod/get_members";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    periods: state.fetch.periods,
  }));
  const { iwuaAsalObj } = useSelector((state) => state.obj);
  const { refetchKey } = useSelector((state) => state.global);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const { open, handleCancel, handleOpen } = useModalToggle();
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        fullNames: e.target.value == "" ? null : e.target.value,
        usrInstId: iwuaAsalObj?.instId,
        start: 0,
        limit: null,
      })
    );
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };
  const handleView = async () => {
    showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchMyMembersData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        usrInstId: iwuaAsalObj?.instId,
      })
    );
  }
  useEffect(() => {
    if (refetchKey == 2) {
      fetchMyMembersData();
    }
  }, [refetchKey]);

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, record, index) => {
        if (record?.isGroup) {
          return {
            children: (
              <div className="scheme-custom-header">
                {record?.usrMemberTypeHeader}
              </div>
            ),
            props: { colSpan: columns?.length },
          };
        }

        let num = 1;
        for (let i = 0; i < index; i++) {
          if (data[i].isGroup) {
            num = 1;
          } else {
            num++;
          }
        }
        return num;
      },
    },
    {
      title: "Name",
      dataIndex: "fullNames",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Member Type",
      dataIndex: "usrMemberType",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "County",
      dataIndex: "countyName",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Subcounty",
      dataIndex: "subCountyName",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Location",
      dataIndex: "locationName",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Sublocation",
      dataIndex: "subLocationName",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Block",
      dataIndex: "farmBlockNames",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Date Registered",
      dataIndex: "createdDate",
      render: (text, record) => {
        if (record?.isGroup) {
          return { props: { colSpan: 0 } };
        }
        return text ? moment(text).format("DD-MM-YYYY HH:mm:ss") : "--";
      },
    },
    {
      title: "ID No.",
      dataIndex: "usrNationalId",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Actions",
      render: (item, record) => {
        if (record.isGroup) return { props: { colSpan: 0 } };
        return (
          <>
            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              trigger={"click"}
              menu={{ items: settingItems }}
              placement="bottom"
            >
              <button onClick={() => setProdd(item)}>
                <img src={svg27} alt="svg27" />
              </button>
            </Dropdown>
          </>
        );
      },
    },
  ];

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1 ">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between  gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search member..."}
            />
          </div>
          <div className="w-[150px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />
              <span className="ml-1">Add Member</span>
            </button>
          </div>
        </div>

        <Table
          rowClassName={(record) => (record.isGroup ? "group-row" : "")}
          rowSelection={false}
          bordered={false}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchMyMembersData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          rowKey="key"
          columns={columns}
          dataSource={data}
          scroll={{
            x: 1200,
          }}
          className="mt-[1.94rem] custom-tables"
          loading={loading}
        />
      </div>
      <MembersView onClose={onClose} open={openDrawer} prodd={prodd} />
      <MembersAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchMyMembersData}
        prodd={prodd}
      />
    </div>
  );
}

export default MembersTable;
